import { OK, CREATED, UNPROCESSABLE_ENTITY, UNAUTHORIZED } from '../util'
import {setCookie} from '../util'
import store from "./index";

const state = {
    history: null,
    lastChatId: null,
    chatAreaHeight: null,
    newChat: null,
    connectStatus: null,
    unreadChatNum: 0,
    faviconUrl: 'images/favicon.ico',
    chatReadReleaseDate: '2021-11-10 12:10'
}

const getters = {
}

const mutations = {
    setLastChatId (state, data) {
        state.lastChatId = data.chat_id
    },
    // faviconを通常に戻す
    returnFavicon(state) {
        var obj = document.getElementById("favicon");
        obj.href = state.faviconUrl;
    },
    // faviconに未読メッセージ数を表示
    changeFavicon (state, num) {
        if (num >= 99) num = 99
        // canvasの準備
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        // 元にするfaviconの読み込み
        var img = new Image();
        img.onload = function() {
            // canvasに元のfaviconを描画
            var w = img.width;
            var h = img.height;
            canvas.width = w;
            canvas.height = h;
            ctx.drawImage(img, 0, 0);

            // 通知数部分の描画
            ctx.fillStyle = '#ff0000';
            ctx.fillRect(w*0.1, h*0.3, w*0.8, h*0.8);
            ctx.font = 'bold ' + w*0.5 + 'px MS PGothic';
            ctx.textAlign = 'center';
            ctx.textBaseline  = 'middle';
            ctx.fillStyle = '#ffffff';
            ctx.fillText(num, w*0.5, h*0.7);

            // 生成したfaviconを変換して設定
            var url = canvas.toDataURL('image/png');
            var faviconTag = document.querySelector('link[rel="icon"]');
            faviconTag.href = url;
        }

        // 元のfavicon(下地)
        img.src = state.faviconUrl;
    },
    // 既読メッセージを既読済みとしてstate.historyにデータを追加する
    setReadMessage(state, data) {
        // 反映が遅いので一度空にしてる
        const tempHistory = state.history;
        state.history = '';
        tempHistory[data.index].user_read_chat_id = data.user_read_chat_id;
        state.history = tempHistory;
    }
}

const actions = {
    // 閲覧したメッセージに既読処理を行う
    async readMessage(context, data) {
        const response = await axios.post('/api/message/read', data)
        state.history.forEach(function(val,index,ar){
            // state.historyデータ内の既読したメッセージにuser_read_chat_idを設定する
            if (val.chat_id === response.data.chat_id) {
                context.commit('setReadMessage', {
                    index: index,
                    user_read_chat_id: response.data.user_read_chat_id
                })
            }
        });

        if (response.status === OK) {
            return true
        }
    },
    async postMessage (context, data) {
        const response = await axios.post('/api/message', data)
        if (response.status === OK) {
            return true
        }
    },
    async getMessageHistory (context, data) {
        const response = await axios.post('/api/message/history', data)
        var before_chatarea_height = 0
        if (state.chatAreaHeight) {
            before_chatarea_height = state.chatAreaHeight.get(0).scrollHeight
        }

        if (response.status === OK && response.data.length !==0) {
            context.commit('setLastChatId', response.data[0])
            await actions.setHistory(response.data)
            if (state.chatAreaHeight) {
                const after_chatarea_height = state.chatAreaHeight.get(0).scrollHeight
                state.chatAreaHeight.scrollTop(after_chatarea_height - before_chatarea_height)
            }
            return true
        }
    },
    setHistory: async function (data) {
        if (state.history) {
            var history = [...state.history].reverse()
            var history_length = Object.keys(history).length

            Object.keys(data.reverse()).forEach(function (key) {
                history[history_length++] = data[key]
            });

            state.history = history.reverse()
        } else {
            state.history = data
        }

        state.history.forEach(function (val, index, ar) {
            // 既読処理のリリース日以前、もしくは会員登録日以前の場合は既読済みにする
            if (val.created_at <= state.chatReadReleaseDate || val.created_at < store.state.auth.user.created_at) {
                state.history[index].user_read_chat_id = true;
            }

            // [To: 13]のようにto付きの部分の文字列を<span class="message-to">To</span>に置き換える
            const to_match_all = val.message.match(/\[To:.+[0-9]\]/g)
            if (!to_match_all) return
            to_match_all.forEach(function (val, key, ar) {
                state.history[index].message = state.history[index].message.replace(val, '<span class="message-to">To</span>')
            });
        });
    },
    async addHistory(context, data) {
        // 最新のチャットを反映させる。反映が遅いので苦肉の策で一度state.historyを空にしている。。
        const history_length = state.history.length
        const origin_history = state.history
        state.history = []
        state.history = origin_history

        // [To: 13]のようにメンション付きの部分の文字列を<span class="message-to">To</span>に置き換える
        const to_match_all = data.message.match(/\[To: ([0-9]{1,})\]/g)
        var mention_user_ids = []
        if (to_match_all) {
            to_match_all.forEach(function(val,index,ar){
                data.message = data.message.replace( val, '<span class="message-to">To</span>' )
                // To: ××のuser_idのみを配列に格納する
                const regexp = /\[To: ([0-9]{1,})\]/g;
                const regexp_result = regexp.exec(val)
                mention_user_ids.push(Number(regexp_result[1]))
            });
        }

        // stateに格納
        state.history[history_length] = {
            chat_id: data.chat_id,
            message: data.message,
            name: data.send_user.name,
            user_id: data.send_user.user_id,
            user_read_chat_id: data.user_read_chat_id,
            created_at: data.created_at,
        }

        // 画面がアクティブではなく、自分以外の送信者の場合にメッセージアイコンを表示。faviconに未読件数を表示
        if (! document.hasFocus() && data.user_id !== data.send_user.user_id) {
            // chatアイコンの設定
            state.newChat = true
            // faviconの設定
            context.commit('changeFavicon', ++state.unreadChatNum)
        }
        // メンションが指定されていて、その相手が自分以外だった場合メッセージアイコンを非表示
        if (mention_user_ids.length && mention_user_ids.indexOf(data.user_id) === -1) {
            state.newChat = false
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
